import type { BuildType } from "./types";

/**
 * How a source becomes a running container, in the order the two forms offer it.
 *
 * This exists because the app settings screen was rendering the enum straight
 * into a `<select>`, so customers were reading raw builder identifiers as
 * their options. The create form had labels; the edit form did not, which is
 * the worst of both — the same choice named two different ways depending on
 * which screen you were on.
 *
 * The values are the API's (and Dokploy's) and must not change. The words are
 * ours and are in `app.json` under `build`, so both forms read one set of
 * them. Railpack keeps its name in the label there because it is genuinely
 * public — Dokploy's successor to Nixpacks — and outcome still leads.
 */
export const BUILD_TYPES: BuildType[] = ["railpack", "dockerfile", "static"];
